import React from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';
import DownloadIcon from '@material-ui/icons/GetApp';

const AddLogFilesDrawerTemplateSection = ({ classes, downloadTemplate }) => {
  return (
    <>
      <Grid item>
        <Typography variant="h6">Step 1: Download</Typography>
      </Grid>

      <Grid container alignItems="center" className={classes.buttonContainer}>
        <Button
          title="Add Log FIle"
          color="primary"
          variant="contained"
          size="large"
          onClick={() => downloadTemplate()}
        >
          <DownloadIcon fontSize="small" />
          TEMPLATE
        </Button>
        <Typography className={classes.textStyle}>
          Please download this Excel template to fill out the log file{' '}
        </Typography>
      </Grid>
    </>
  );
};

const styles = (theme) => ({
  buttonContainer: {
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  textStyle: {
    marginTop: theme.spacing(2),
    color: theme.palette.secondary.light,
  },
});

export default withStyles(styles)(AddLogFilesDrawerTemplateSection);
